import React from 'react'

export const trimText = (text: string, max: number) => {
  return text.length > max ? text.slice(0, max) + '...' : text
}

// テキスト内のURLをリンクに変換する
export const autoCreateUrlLink = (text: string) => {
  const parts = text.split(/(\s+)/).map((part, index) => {
    if (part.match(/(http|https):\/\/([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?/)) {
      return (
        <a
          key={index}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          className="text-main-blue underline"
        >
          {part}
        </a>
      )
    }
    return <span key={index}>{part}</span>
  })
  return parts
}
